import IconNoProfileImage from "../assets/icons/no-profile-picture.svg?string";
//
import { Table } from ":src/components/list";
import { EmptyTable } from "../components/empty-table";
import { accept_request, type _AcceptRequest } from "../apis";
import { global } from ":shared/app";
//
import type { _SolidState } from ":setup/qstate";
import { createMemo } from "solid-js";
import type { UserRequests } from "../../SHARED/_model";

export type Props = {
  details: UserRequests;
  onUpdate: (props: UserRequests) => void;
};

export function TableRecievedRequests(props: Props) {
  const $info = createMemo(() => {
    const user_requests = props.details;
    return {
      role: user_requests.role,
      requests: user_requests.received_requests,
    };
  });
  return (
    <Table
      _items={$info().requests}
      _fallback={<EmptyTable msg="You do not have any requests in your inbox " />}
      _emptyKey="UNKOWN"
      _class={{
        desktop: {
          table: "px0.2",
          headersWrapper: "min-h-2rem bg-bg-alt font-semibold rounded-t-md items-center content-start mb-2",
          headersAndCells: "flex items-center justify-start text-0.75rem px-2 flex-1",
          rows: "py-1 mb-2",
        },
        phone: {
          wrapper: "gap-y-3 py-2 px-0.5",
          card: "items-center shadow-md py-2 px-2 gap-y-2 rounded-xl !justify-between text-0.8rem ring-border-card ring-2",
          header: "w-100px",
          cell: "justify-start overflow-x-auto",
        },
      }}
      _headers={{
        User: {
          class: {
            desktop: {
              header: "min-w-200px whitespace-nowrap",
            },
          },
          hideHeader: {
            phone: true,
          },
          key: ({ item, emptyKey }) => {
            const image = typeof item.image !== "string" ? IconNoProfileImage : item.image;
            return (
              <div class="flex flex-row w-full h-full">
                <img class="w-80px h-80px rounded-full object-cover z-0" src={image} alt={"profile_image"} />
                <p class="flex flex-col mx-3 mt-1.5">
                  <span class="font-bold text-0.8rem ">{`${item.name ?? emptyKey}`}</span>
                  <span>{`${item.reference2 ?? "#000000"}`}</span>
                </p>
              </div>
            );
          },
        },
        "Email Address": {
          class: {
            desktop: {
              header: "min-w-200px whitespace-nowrap",
            },
          },
          key: "email",
        },
        // Type: {
        //   key: "type",
        // },
        Action: {
          class: {
            desktop: {
              header: "min-w-200px",
            },
          },
          key: ({ item }) => {
            return (
              <div class="flex flex-row space-x-2  <sm:(w-full justify-center text-0.7em) ">
                <span
                  class="bg-success-shade text-success cursor-pointer rounded-2 px-2 py-1"
                  onclick={() => {
                    global.store.actions.popop.pushConfirmDialog({
                      type: "success",
                      message: `Are you sure you want to accept ${item.name} request?!`,
                      events: {
                        async onConfirmed() {
                          return accept_request
                            .put({
                              item,
                              status: "accepted",
                            })
                            .then((data) => {
                              global.store.actions.toast.pushToast({
                                type: "success",
                                message: "member joined team successfully!, welcome them.",
                              });
                              data.received_requests = $info().requests.filter((x) => x.id !== item.id);
                              props.onUpdate?.(data);
                            });
                        },
                      },
                    });
                  }}
                >
                  Accept
                </span>
                <span
                  class="bg-error-shade text-error cursor-pointer rounded-2 px-2 py-1"
                  onclick={() => {
                    global.store.actions.popop.pushConfirmDialog({
                      type: "warn",
                      message: `Are you sure you want to reject ${item.name} invite?!`,
                      events: {
                        async onConfirmed() {
                          return accept_request
                            .put({
                              item,
                              status: "rejected",
                            })
                            .then(() => {
                              global.store.actions.toast.pushToast({
                                type: "success",
                                message: "member team join rejected!",
                              });
                              const data = props.details;
                              data.received_requests = $info().requests.filter((x) => x.id !== item.id);
                              props.onUpdate?.(data);
                            });
                        },
                      },
                    });
                  }}
                >
                  Remove
                </span>
              </div>
            );
          },
        },
      }}
    />
  );
}
